/* ----------------- React Native Paper Imports --------------- */
import { Appbar } from "react-native-paper";

import Box from "@memorang/ui/components/Box";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
/* ----------------- Component Imports --------------- */
import { router } from "expo-router";
// import ChallengesFolderView from "../components/ChallengesFolderView";

const AllChallengesContainer = () => {
	return (
		<>
			<Appbar.Header mode="medium" elevated>
				<Appbar.BackAction onPress={() => router.back()} />
				<Appbar.Content title="All Challenges" />
			</Appbar.Header>
			<ScrollContainer>
				<Box paddingTop={8}>
					{/* <ChallengesFolderView
						challengesSectionList={challengesSectionList}
						showViewAll={false}
						handleNavigateToChallengesFolder={handleNavigateToChallengesFolder}
					/> */}
				</Box>
			</ScrollContainer>
		</>
	);
};

export default AllChallengesContainer;
